
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/projekt/[id]",
      function () {
        return require("private-next-pages/projekt/[id].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/projekt/[id]"])
      });
    }
  